"use client";

import { ISDUIProductTileVariantRendererProps } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/types";
import { ProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTile";
import { ProductTileSurface } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileSurface";
import { ProductTileType } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileType";
import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import React from "react";

export const SDUIProductTileEvaluateRenderer = ({
  product,
  brand,
  loggingData,
}: ISDUIProductTileVariantRendererProps) => {
  useTraceComponentRender("ProductTileItem");

  return (
    <ProductTile
      productTile={product}
      productTileType={ProductTileType.PRODUCT_ONLY_TILE}
      brand={ILeanProductTile.IBrand.build(brand)}
      productTileSurface={
        loggingData.view_display_page === DisplayPageType.SEARCH_PAGE
          ? ProductTileSurface.SEARCH_PAGE
          : undefined
      }
    />
  );
};
